import type { SelectProps } from '@farmersdog/corgi';
import { Select } from '@farmersdog/corgi';

import type { ChangeEvent } from 'react';

export interface PetsCountInputProps
  extends Omit<SelectProps, 'ref' | 'label'> {
  value: number;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

const MIN_PETS = 1;
const MAX_PETS = 8;
const petsCountArray = Array.from({ length: MAX_PETS }, (_, i) => i + MIN_PETS);

export const PetsCountInput = ({
  value,
  onChange,
  ...props
}: PetsCountInputProps) => (
  <Select
    {...props}
    name="petsCount"
    label="Number of pets"
    value={value}
    onChange={onChange}
  >
    {petsCountArray.map(num => {
      return (
        <option value={num} key={`pet-${num}`}>
          I have {num} dog{num > 1 && 's'}
        </option>
      );
    })}
  </Select>
);
